// @flow
import React, {Fragment} from 'react';
import {FormattedMessage} from 'react-intl';
import gql from 'graphql-tag';
import Experiment from '@homeaway/react-experiment';
import {HA_SERP_PINNED_PROPERTY} from '../../abacus/experiments';

import './PinnedProperty.less';

export const fragments = {
    PinnedPropertyHit: gql`
        fragment PinnedPropertyHit on SERPHit {
            available
            pinned
        }
    `
};
export type SERPHitShape = {
    available: boolean,
    pinned: boolean
};

type Props = {
    children: any,
    available: boolean,
    numResults: number
};

const getTitle = (linguaId: string, available: boolean) => {
    return available ? (
        <FormattedMessage
            id={linguaId}
            description="Pinned property label"
            defaultMessage="Featured property"
        />
    ) : (
        <FormattedMessage
            id="pinnedPropertyUnavailable"
            description="Pinned property unavailable label"
            defaultMessage="This featured property is unavailable on your dates"
        />
    );
};

const getNearbyPropertiesTitle = () => {
    return (
        <h2 className="HitCollection_nearbyTitle">
            <FormattedMessage
                id="expandedSearchNearbyLabel"
                description="Nearby property label"
                defaultMessage="You might like these nearby properties"
            />
        </h2>
    );
};

const PinnedProperty = ({available, children, numResults}: Props) => {
    const nearbyProperties = numResults > 1;

    return (
        <Fragment>
            <Experiment name={HA_SERP_PINNED_PROPERTY} variant={0}>
                <Fragment>
                    <div className="PinnedProperty">
                        <h2>{getTitle('pinnedProperty', available)}</h2>
                        {children}
                    </div>
                    {available &&
                        nearbyProperties &&
                        getNearbyPropertiesTitle()}
                </Fragment>
            </Experiment>

            <Experiment name={HA_SERP_PINNED_PROPERTY} variant={1}>
                <Fragment>
                    <div className="PinnedProperty HA_PINNED_PROPERTY_TEST">
                        <h4>{getTitle('pinnedPropertyAlt', available)}</h4>
                        {children}
                    </div>
                    {!available &&
                        nearbyProperties &&
                        getNearbyPropertiesTitle()}
                </Fragment>
            </Experiment>

            <Experiment name={HA_SERP_PINNED_PROPERTY} variant={2}>
                <Fragment>
                    <div className="PinnedProperty HA_PINNED_PROPERTY_TEST HA_PINNED_PROPERTY_TEST_ALT">
                        <h4 className="bg--color-bg-inverse">
                            {getTitle('pinnedPropertyAlt', available)}
                        </h4>
                        {children}
                    </div>
                    {!available &&
                        nearbyProperties &&
                        getNearbyPropertiesTitle()}
                </Fragment>
            </Experiment>

            <Experiment name={HA_SERP_PINNED_PROPERTY} variant={3}>
                <Fragment>
                    <div className="PinnedProperty HA_PINNED_PROPERTY_TEST HA_PINNED_PROPERTY_TEST_ALT">
                        <h4 className="bg--color-brand">
                            {getTitle('pinnedPropertyAlt', available)}
                        </h4>
                        {children}
                    </div>
                    {!available &&
                        nearbyProperties &&
                        getNearbyPropertiesTitle()}
                </Fragment>
            </Experiment>

            <Experiment name={HA_SERP_PINNED_PROPERTY} variant={4}>
                <Fragment>
                    <div className="PinnedProperty HA_PINNED_PROPERTY_TEST HA_PINNED_PROPERTY_TEST_V4">
                        <div className="bg--color-brand HA_PINNED_PROPERTY_TEST--container">
                            <h4>{getTitle('pinnedPropertyAlt', available)}</h4>
                            {children}
                        </div>
                    </div>
                    {!available &&
                        nearbyProperties &&
                        getNearbyPropertiesTitle()}
                </Fragment>
            </Experiment>
        </Fragment>
    );
};

export default PinnedProperty;
